import { modalRenderer } from '~/modal/modalRendererRegistry';
import { ImportingSpreadsheetModal } from './ImportingSpreadsheetModal';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ImportingSpreadsheet: undefined;
  }
}
modalRenderer.register('ImportingSpreadsheet', (props) => <ImportingSpreadsheetModal {...props} />);
